















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    defaultLocation: {
      type: Object,
      required: true
    }
  }
})
export default class GoBack extends Vue {

}
